<template>
  <div class="lesson py-10 relative">
    <div  class="z-20 absolute w-full">
      <img src="../assets/images/lesson_web_title.png" class="w-[60%] max-w-[700px] mx-auto mb-10 hidden md:block">
      <div v-if="source === '0'">
        <img src="../assets/images/lesson_md_title_nosoft.png" class="w-[85%] max-w-[700px] mx-auto mb-5 md:hidden">
        <img src="../assets/images/lesson_md_nosoft.png" class="w-[97%] mx-auto mb-10 md:hidden">
        <img src="../assets/images/lesson_web_title_nosoft.png" class="w-[55%] max-w-[700px] mx-auto mb-5 hidden md:block">
        <img src="../assets/images/lesson_web_nosoft.png" class="w-[60%] max-w-[700px] mx-auto mb-10 hidden md:block">
        <img src="../assets/images/lesson_signup.png" class="w-[80%] max-w-[300px] mx-auto mb-5 translate-x-3 cursor-pointer" @click="signUP()">
      </div>
      <div v-else>
        <img src="../assets/images/lesson_md_title_soft.png" class="w-[85%] mx-auto mb-5 md:hidden">
        <img src="../assets/images/lesson_md_soft.png" class="w-[88%] mx-auto mb-10 md:hidden">
        <img src="../assets/images/lesson_md_soft1.png" class="w-full mx-auto mb-10 md:hidden">
        <img src="../assets/images/lesson_md_soft2.png" class="w-full mx-auto mb-10 md:hidden">
        <img src="../assets/images/lesson_md_soft3.png" class="w-full mx-auto mb-10 md:hidden">
        <img src="../assets/images/lesson_web_soft.png" class="w-[60%] max-w-[700px] mx-auto mb-20 hidden md:block">
        <img src="../assets/images/lesson_web_soft1.png" class="w-[60%] max-w-[700px] mx-auto mb-10 hidden md:block">
        <img src="../assets/images/lesson_web_soft2.png" class="w-[60%] max-w-[700px] mx-auto mb-20 hidden md:block">
        <img src="../assets/images/lesson_web_soft3.png" class="w-[60%] max-w-[700px] mx-auto mb-10 hidden md:block">
        <img src="../assets/images/lesson_web_soft4.png" class="w-[60%] max-w-[700px] mx-auto mb-10 hidden md:block">
        <img src="../assets/images/lesson_web_soft5.png" class="w-[60%] max-w-[700px] mx-auto mb-10 hidden md:block">
        <img src="../assets/images/lesson_signup.png" class="w-[80%] max-w-[300px] mx-auto mb-5 translate-x-3 cursor-pointer" @click="signUP()">
      </div>
      <div class="modal z-[101]" :style="{ height: windowHeight }" v-if="showModal">
        <div class="modal-content shadow p-5 text-[#868686]">
          <img src="../assets/images/lesson_qrcode.png" class="w-[200px] mx-auto mb-2">
          <p class="text-black font-bold">請加入「程曦_企業AI數位培訓」官方LINE進行課程報名！</p>
          <p class="my-3 text-xs text-[#9d9d9d]">*不支援網頁報名</p>
          <div class="flex items-center justify-center text-white">
            <button class="rounded-full bg-[#05b030]  py-1 w-1/3 cursor-pointer" @click="showModal = false">關閉</button>
          </div>
        </div>
      </div>
    </div>
    <div class="z-10 fixed top-0 w-full">
      <img src="../assets/images/lesson_bg_shine.png"  class="w-full max-w-[700px] mx-auto scale-125">
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import liff from '@line/liff'
export default {
  name: 'LessonView',
  components: {
    // HelloWorld
  },
  data () {
    return {
      source: 0,
      showModal: false
    }
  },
  created () {
    this.source = this.$route.query.source
  },
  async mounted () {
    window.scrollTo(0, 0)
    try {
      await liff.init({ liffId: '1661400637-Gvq3v5rd' })
      this.isLiffBrowser = liff.isInClient()
    } catch (error) {
      console.error('LIFF 初始化失敗', error)
    }
  },
  methods: {
    signUP () {
      const userAgent = navigator.userAgent.toLowerCase()
      const isMobile = /iphone|ipod|ipad|android/i.test(userAgent)
      if (this.isLiffBrowser) {
        alert('打開問問')
      } else if (isMobile) {
        location.href = 'https://line.me/R/ti/p/@570gvyuo'
      } else {
        this.showModal = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.lesson{
  background-image: radial-gradient(circle at 50% 40%, #1c5ee7, #1342ac 34%, #08082d 71%);
  height: 100vh;
  overflow-y: scroll;
}
.modal{
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .modal-content{
    background: white;
    border-radius: 8px;
    width: 80%;
    max-width: 380px;
  }
}
</style>
